import { useState, useEffect } from 'react'

function useEsMovil() {
  const [esMovil, setEsMovil] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth <= 820 : false
  )
  useEffect(() => {
    const mq = window.matchMedia('(max-width: 820px)')
    const handler = e => setEsMovil(e.matches)
    mq.addEventListener('change', handler)
    return () => mq.removeEventListener('change', handler)
  }, [])
  return esMovil
}

function LogoEduNova({ size = 28 }) {
  return (
    <img src="/edunova-logo.png" alt="EduNova"
      style={{ width: size, height: size, objectFit: 'contain', flexShrink: 0 }} />
  )
}

function Wordmark({ size = 18 }) {
  return (
    <div style={{ display:'flex', alignItems:'baseline', fontWeight:900, fontSize:size, letterSpacing:'-0.5px' }}>
      <span style={{ color:'#F0D878' }}>English</span>
      <span style={{ color:'#0D1F52' }}>Bridge</span>
    </div>
  )
}

function formatoCOP(valor) {
  if (valor === 0) return 'Gratis'
  return '$' + valor.toLocaleString('es-CO') + ' COP'
}

// Estructura de 5 planes aprobada en el documento de estrategia
// (Agosto 2026): un Free permanente y un Starter solo-app en los
// extremos, para captar tanto a quien quiere probar sin compromiso
// como a quien solo quiere la app sin clases en vivo (el segmento
// que hoy cubre Duolingo y que EnglishBridge no atendia).
// Orden de izquierda a derecha: del mas barato al mas caro (Free
// primero, Mastery al final), con Advanced como el plan destacado
// ("MAS POPULAR").
const PLANES = [
  {
    id: 'free', emoji: '🎁', nombre: 'Free', precio: 0, periodo: 'por 3 dias', porDia: null,
    paraQuien: 'Para cualquiera que quiera probar sin compromiso',
    desc: 'Acceso completo a todo el contenido durante 3 dias, el examen de nivel, y 1 clase grupal en vivo de prueba.',
    color: '#22C55E', popular: false, esFree: true
  },
  {
    id: 'starter', emoji: '🎧', nombre: 'Starter', precio: 59900, periodo: '/mes', porDia: 'Menos de $2.000 al dia',
    paraQuien: 'Para quien solo quiere estudiar por su cuenta, sin clases en vivo',
    desc: 'Currículo completo A1-C1 a tu propio ritmo, retos diarios y juegos. Sin clases en vivo.',
    color: '#059669', popular: false, esFree: false
  },
  {
    id: 'plus', emoji: '📅', nombre: 'Plus', precio: 150900, periodo: '/mes', porDia: 'Menos de $5.100 al dia',
    paraQuien: 'Para quien quiere progreso guiado con clases grupales',
    desc: 'Currículo A1-B1, 3 clases grupales en vivo por semana, 1 clase privada al mes, retos diarios y gamificacion completa.',
    color: '#1B3A8C', popular: false, esFree: false
  },
  {
    id: 'advanced', emoji: '💎', nombre: 'Advanced', precio: 890900, periodo: '/8 meses', porDia: 'Menos de $3.800 al dia',
    paraQuien: 'Para quien quiere avanzar rapido con acompañamiento',
    desc: 'Currículo A1-C1 completo, 5 clases grupales en vivo por semana, 4 clases privadas al mes con profesores nativos de habla inglesa, acceso prioritario.',
    color: '#D4AF37', popular: true, esFree: false,
    ahorro: 'Ahorras $316.300 vs. pagar Plus mes a mes durante 8 meses'
  },
  {
    id: 'mastery', emoji: '👑', nombre: 'Mastery', precio: 1290000, periodo: '/año', porDia: 'Menos de $3.600 al dia',
    paraQuien: 'Para quien busca certificacion y mentoria VIP',
    desc: 'Todo lo de Advanced, mas mentor personal, clases presenciales incluidas, clases con profesores nativos de habla inglesa, y certificacion final.',
    color: '#0D1F52', popular: false, esFree: false
  },
]

export default function Precios({ onContinuar }) {
  const esMovil = useEsMovil()

  return (
    <div style={{ minHeight:'100vh', background:'#F8FAFF', fontFamily:'system-ui, sans-serif', padding: esMovil ? '24px 16px 60px' : '40px' }}>
      <div style={{ maxWidth:1320, margin:'0 auto' }}>

        <button onClick={() => onContinuar({ esBack: true })}
          style={{ background:'none', border:'none', cursor:'pointer', fontSize:14, color:'#6B7280', fontFamily:'inherit', marginBottom:24, display:'flex', alignItems:'center', gap:8 }}>
          <LogoEduNova size={24} /> <Wordmark size={16} /> <span style={{ marginLeft:8 }}>← Volver al inicio</span>
        </button>

        <div style={{ textAlign:'center', marginBottom: esMovil ? 32 : 48 }}>
          <h1 style={{ fontSize: esMovil ? 26 : 36, fontWeight:900, color:'#1A1A2E', marginBottom:12 }}>
            Elige tu plan
          </h1>
          <p style={{ fontSize: esMovil ? 15 : 17, color:'#6B7280' }}>
            Precios en pesos colombianos. Empieza gratis, mejora cuando quieras.
          </p>
        </div>

        <div style={{ display:'grid', gridTemplateColumns: esMovil ? '1fr' : 'repeat(5,1fr)', gap:16 }}>
          {PLANES.map(p => (
            <div key={p.id} style={{
              border: '2px solid ' + (p.popular ? p.color : '#E2E6F0'),
              borderRadius:18, padding:22, position:'relative',
              background: p.popular ? p.color + '0A' : '#fff',
              display:'flex', flexDirection:'column'
            }}>
              {p.popular && (
                <div style={{ position:'absolute', top:-14, left:'50%', transform:'translateX(-50%)', background:p.color, color:'#fff', borderRadius:999, padding:'4px 16px', fontSize:12, fontWeight:800, whiteSpace:'nowrap' }}>
                  ⭐ MAS POPULAR
                </div>
              )}
              <div style={{ fontSize:30, marginBottom:10 }}>{p.emoji}</div>
              <div style={{ fontSize:17, fontWeight:800, color:'#1A1A2E', marginBottom:4 }}>{p.nombre}</div>
              <div style={{ fontSize:11.5, color:'#9CA3AF', marginBottom:12, lineHeight:1.4, minHeight: esMovil ? 'auto' : 30 }}>{p.paraQuien}</div>

              <div style={{ fontSize: p.esFree ? 22 : 21, fontWeight:900, color:p.color, marginBottom:2 }}>
                {formatoCOP(p.precio)}
              </div>
              <div style={{ fontSize:12, color:'#9CA3AF', marginBottom: p.porDia ? 2 : 14 }}>{p.periodo}</div>
              {p.porDia && (
                <div style={{ fontSize:11.5, color: p.color, fontWeight:700, marginBottom:14 }}>{p.porDia}</div>
              )}

              {p.ahorro && (
                <div style={{ fontSize:11.5, color:'#166534', background:'#F0FDF4', border:'1px solid #BBF7D0', borderRadius:8, padding:'6px 9px', marginBottom:14, lineHeight:1.4 }}>
                  💰 {p.ahorro}
                </div>
              )}

              <div style={{ fontSize:13, color:'#6B7280', lineHeight:1.6, marginBottom:16, flex:1 }}>{p.desc}</div>

              <button onClick={() => onContinuar(p)}
                style={{ width:'100%', padding:'12px', background: p.popular ? p.color : 'transparent',
                  color: p.popular ? '#fff' : p.color, border:'2px solid ' + p.color, borderRadius:10,
                  fontFamily:'inherit', fontSize:14, fontWeight:700, cursor:'pointer' }}>
                {p.esFree ? 'Empezar gratis' : 'Elegir plan'}
              </button>

              {!p.esFree && (
                <div style={{ fontSize:10.5, color:'#9CA3AF', textAlign:'center', marginTop:8 }}>
                  Cancela cuando quieras. Sin permanencia minima.
                </div>
              )}
            </div>
          ))}
        </div>

        <p style={{ textAlign:'center', fontSize:13, color:'#9CA3AF', marginTop:32 }}>
          Paquetes sueltos de clases privadas tambien disponibles para cualquier plan, sin necesidad de cambiarte de plan.
        </p>
      </div>
    </div>
  )
}
